"use client";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { useEffect, useId, useRef, } from "react";
var INITIAL_SCROLL_STATE = {
    isScrolling: false,
    isScrollingUp: false,
    isScrollingDown: false,
    isScrollingLeft: false,
    isScrollingRight: false,
    scrollTop: 0,
    scrollBottom: 0,
    scrollLeft: 0,
    scrollRight: 0,
};
var INITIAL_SCROLL_EVENTS = {};
export function useScroll(callback, isActive, id, ref //ScrollRefObject
) {
    if (isActive === void 0) { isActive = false; }
    if (id === void 0) { id = "window"; }
    var hookID = useId();
    var callbackRef = useRef(callback);
    var _a = typeof callback === "function"
        ? __assign(__assign({}, INITIAL_SCROLL_EVENTS), { onScroll: callback }) : __assign(__assign({}, INITIAL_SCROLL_EVENTS), callback), onScrollStart = _a.onScrollStart, onScroll = _a.onScroll, onScrollStop = _a.onScrollStop;
    useEffect(function () {
        if (!isActive)
            return;
        var element = (ref === null || ref === void 0 ? void 0 : ref.current)
            ? ref === null || ref === void 0 ? void 0 : ref.current
            : !ref && typeof window !== "undefined"
                ? window
                : ref;
        addListenToScroll(element, {
            onScrollStart: onScrollStart,
            onScroll: onScroll,
            onScrollStop: onScrollStop,
        }, id, hookID);
        return function () {
            removeListenToScroll(element, {
                onScrollStart: onScrollStart,
                onScroll: onScroll,
                onScrollStop: onScrollStop,
            }, id);
        };
    }, [ref, isActive, hookID, onScrollStart, onScroll, onScrollStop]);
}
var SCROLL_LISTENERS = new Map();
var SCROLL_ID_MAP = {};
function addListenToScroll(element, _a, id, hookID) {
    var onScroll = _a.onScroll, onScrollStart = _a.onScrollStart, onScrollStop = _a.onScrollStop;
    if (!element)
        return;
    var entry;
    if (!SCROLL_LISTENERS.has(element)) {
        var callbacks_1 = {
            onScrollStart: new Set(),
            onScroll: new Set(),
            onScrollStop: new Set(),
        };
        var x_1 = 0;
        var y_1 = 0;
        var startX_1 = 0;
        var startY_1 = 0;
        var offsetX_1 = 0;
        var offsetY_1 = 0;
        var diffX_1 = 0;
        var diffY_1 = 0;
        var lastX_1 = 0;
        var lastY_1 = 0;
        var isScrolling_1 = false;
        var timeout_1;
        var triggerCallbacks_1 = function (state, callbacks, event) {
            var e_1, _a;
            try {
                for (var callbacks_2 = __values(callbacks), callbacks_2_1 = callbacks_2.next(); !callbacks_2_1.done; callbacks_2_1 = callbacks_2.next()) {
                    var callback = callbacks_2_1.value;
                    callback(__assign(__assign({}, state), { offsetX: offsetX_1, offsetY: offsetY_1, diffX: diffX_1, diffY: diffY_1, isScrollingUp: y_1 < lastY_1, isScrollingDown: y_1 > lastY_1, isScrollingLeft: x_1 < lastX_1, isScrollingRight: x_1 > lastX_1 }), event);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (callbacks_2_1 && !callbacks_2_1.done && (_a = callbacks_2.return)) _a.call(callbacks_2);
                }
                finally { if (e_1) throw e_1.error; }
            }
        };
        entry = {
            state: __assign(__assign({}, INITIAL_SCROLL_STATE), { isScrolling: false }),
            callbacks: callbacks_1,
            handler: function (event) {
                var target = event.target;
                if (!target)
                    return;
                var state = computeState(element);
                lastX_1 = x_1;
                lastY_1 = y_1;
                x_1 = state.scrollLeft;
                y_1 = state.scrollTop;
                offsetX_1 = x_1 - startX_1;
                offsetY_1 = y_1 - startY_1;
                diffX_1 = lastX_1 - x_1;
                diffY_1 = lastY_1 - y_1;
                if (!isScrolling_1) {
                    startX_1 = state.scrollLeft;
                    startY_1 = state.scrollTop;
                    triggerCallbacks_1(__assign(__assign({}, state), { isScrolling: true }), callbacks_1.onScrollStart, event);
                }
                if (timeout_1) {
                    isScrolling_1 = true;
                    clearTimeout(timeout_1);
                }
                triggerCallbacks_1(__assign(__assign({}, state), { isScrolling: true }), callbacks_1.onScroll, event);
                timeout_1 = setTimeout(function () {
                    isScrolling_1 = false;
                    startX_1 = state.scrollLeft;
                    startY_1 = state.scrollTop;
                    offsetX_1 = 0;
                    offsetY_1 = 0;
                    triggerCallbacks_1(__assign(__assign({}, state), { isScrolling: isScrolling_1 }), callbacks_1.onScrollStop, event);
                }, 100);
            },
        };
        SCROLL_LISTENERS.set(element, entry);
        element.addEventListener("scroll", entry.handler, { passive: true });
    }
    else {
        entry = SCROLL_LISTENERS.get(element);
    }
    if (onScrollStart) {
        entry === null || entry === void 0 ? void 0 : entry.callbacks.onScrollStart.add(onScrollStart);
    }
    if (onScroll) {
        entry === null || entry === void 0 ? void 0 : entry.callbacks.onScroll.add(onScroll);
    }
    if (onScrollStop) {
        entry === null || entry === void 0 ? void 0 : entry.callbacks.onScrollStop.add(onScrollStop);
    }
    if (entry && !SCROLL_ID_MAP[id]) {
        SCROLL_ID_MAP[id] = entry;
    }
}
function removeListenToScroll(element, _a, id) {
    var onScroll = _a.onScroll, onScrollStart = _a.onScrollStart, onScrollStop = _a.onScrollStop;
    if (!element)
        return;
    var entry = SCROLL_LISTENERS.get(element);
    if (!entry)
        return;
    if (onScrollStart) {
        entry.callbacks.onScrollStart.delete(onScrollStart);
    }
    if (onScroll) {
        entry.callbacks.onScroll.delete(onScroll);
    }
    if (onScrollStop) {
        entry.callbacks.onScrollStop.delete(onScrollStop);
    }
    var totalCallbackSize = entry.callbacks.onScrollStart.size +
        entry.callbacks.onScroll.size +
        entry.callbacks.onScrollStop.size;
    if (totalCallbackSize === 0) {
        element.removeEventListener("scroll", entry.handler);
        SCROLL_LISTENERS.delete(element);
        delete SCROLL_ID_MAP[id];
    }
}
function computeState(element, isScrolling) {
    if (isScrolling === void 0) { isScrolling = false; }
    var isWindow = element === window;
    var scrollTop = isWindow ? window.scrollY : element.scrollTop;
    var scrollBottom = scrollTop;
    var scrollLeft = isWindow
        ? window.scrollX
        : element.scrollLeft;
    var scrollRight = scrollLeft;
    var state = {
        isScrolling: isScrolling,
        isScrollingUp: false,
        isScrollingDown: false,
        isScrollingLeft: false,
        isScrollingRight: false,
        scrollTop: scrollTop,
        scrollBottom: scrollBottom,
        scrollLeft: scrollLeft,
        scrollRight: scrollRight,
    };
    return state;
}
